<template>
  <div id="index" ref="appRef">
    <div class="bg">
      <dv-loading v-if="loading">Loading...</dv-loading>
      <div v-else class="host-body">
        <div class="d-flex jc-center host-body-bg" v-if="!isBar">
          <div class="title" v-if="!title">
            <img src="../../assets/title.png" class="title-img" />
            <span class="title-text">土拉宝全国大数据</span>
            <!-- <dv-decoration-6 class="dv-dec-6" :reverse="true" :color="['#50e3c2', '#67a1e5']" /> -->
          </div>
          <div class="title" v-else>
            <img :src="imageSrc" class="title-img" />
            <span style="font-size: 40px" class="title-text">{{ title }}</span>
            <!-- <dv-decoration-6 class="dv-dec-6" :reverse="true" :color="['#50e3c2', '#67a1e5']" /> -->
          </div>
        </div>

        <!-- 第二行 -->
        <div class="time-div" v-if="!isBar">
          <div class="d-flex time-div-1">
            <span class="time-family">{{ year }} </span>年
            <span class="time-family">&nbsp;{{ month }} </span>月
            <span class="time-family">&nbsp;{{ day }} </span>日
            <span class="time-mag">
              <span class="time-family">{{ hour }}</span> :
              <span class="time-family">{{ minutes }}</span> :
              <span class="time-family">{{ seconds }}</span>
            </span>
            星期<span class="time-family">{{ dateWeek }}</span>
            <!-- <span class="text">{{ dateYear }}{{ dateDay }}{{ dateWeek }}</span> -->
          </div>
        </div>

        <div class="body-box">
          <!-- 第三行数据 -->
          <div class="content-box">
            <!-- 左边 -->
            <div class="left-box">
              <!--  运输统计-->
              <div class="transport-box">
                <transportStatistics />
              </div>
              <!-- 台班统计 -->
              <div class="team-box">
                <teamStatistics />
              </div>
              <!-- 供应链统计 -->
              <div class="supply-box">
                <supplyStatistics />
              </div>
            </div>

            <!-- 中间 -->
            <div class="middle-box">
              <transportTimesStatistics />
            </div>
            <!-- 右边 -->
            <div class="right-box">
              <!-- 重点城市 -->
              <div class="emphasis-box">
                <emphasisCity />
              </div>
              <!-- 现场图片 -->
              <div class="img-box">
                <sceneImg />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import drawMixin from '../../utils/drawMixin'
import { formatTime } from '../../utils/index.js'
import transportStatistics from './transportStatistics.vue' // 运输统计
import teamStatistics from './teamStatistics.vue' // 台班统计
import supplyStatistics from './supplyStatistics.vue' // 供应链统计
import transportTimesStatistics from './transportTimesStatistics.vue' // 运次统计
import emphasisCity from './emphasisCity.vue' // 重点城市
import sceneImg from './sceneImg.vue' // 现场图片
import { getInitAccessToken, getAccessToken } from '../../api/holdMy.js'
import { setToken, getToken } from '../../utils/getToken'

export default {
  mixins: [drawMixin],
  data() {
    return {
      refreshTokening: null,
      timing: null,
      loading: true,
      dateWeek: '',
      weekday: ['日', '一', '二', '三', '四', '五', '六'],
      year: '',
      month: '',
      day: '',
      hour: '',
      minutes: '',
      seconds: '',
      title: this.$route.query.title,
      isBar: this.$route.query.bar,
      imageSrc: '',
    }
  },
  components: {
    transportStatistics,
    teamStatistics,
    supplyStatistics,
    transportTimesStatistics,
    emphasisCity,
    sceneImg,
  },
  mounted() {
    this.timeFn()
    // this.cancelLoading()
    // 获取token
    this.GetInitAccessToken()
    // 定时刷新token
    this.GetAccessToken()
    this.imageSrc = require(`../../assets/${this.$route.query.title}.png`)
  },
  beforeDestroy() {
    clearInterval(this.timing)
  },
  methods: {
    // 动态显示时间
    timeFn() {
      this.timing = setInterval(() => {
        this.dateDay = formatTime(new Date(), 'HH: mm: ss')
        this.dateYear = formatTime(new Date(), 'yyyy-MM-dd')
        this.dateWeek = this.weekday[new Date().getDay()]
        //年
        this.year = new Date().getFullYear()
        //月份是从0月开始获取的，所以要+1;
        var month = new Date().getMonth() + 1
        this.month = month < 10 ? '0' + month : month
        //日
        var day = new Date().getDate()
        this.day = day < 10 ? '0' + day : day
        var hour = new Date().getHours() // 时
        this.hour = hour < 10 ? '0' + hour : hour
        var minutes = new Date().getMinutes() // 分
        this.minutes = minutes < 10 ? '0' + minutes : minutes
        var seconds = new Date().getSeconds() //秒
        this.seconds = seconds < 10 ? '0' + seconds : seconds
      }, 1000)
    },
    cancelLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },

    // 初始化token
    GetInitAccessToken() {
      getInitAccessToken()
        .then((res) => {
          console.log(res)
          if (res.result == 0 && res.userdata && res.userdata.token) {
            setToken('holdpjToken', res.userdata.token)
            setToken('holdpjRefreshToken', res.userdata.refreshToken)
            this.loading = false
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },

    // 刷新token 30 * 57 * 1000 半个小时
    GetAccessToken() {
      if (this.refreshTokening) {
        clearInterval(this.refreshTokening)
      }
      this.refreshTokening = setInterval(() => {
        let data = {
          type: '2', // 传入用户id
          refreshToken: getToken('holdpjRefreshToken'),
        }
        getAccessToken(data)
          .then((res) => {
            if (res.result == 0 && res.userdata && res.userdata.token) {
              setToken('holdpjToken', res.userdata.token)
              setToken('holdpjRefreshToken', res.userdata.refreshToken)
            }
          })
          .catch((error) => {
            console.log(error)
          })
      }, 30 * 57 * 1000)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/index.scss';
</style>
